import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/landing/legal/legal-page'

import { LegalPage } from '@/components/landing/legal/legal-page'
import { siteConfig } from '@/constants/site'

const sections: LegalSection[] = [
    {
        id: 'quotes',
        title: "Quotes and price ranges",
        body: <p>The prices on this site are typical ranges. They remain estimates until your technician confirms the exact price on site, which happens before any work begins.</p>
    },
    {
        id: 'diagnostic-fee',
        title: "Diagnostic fee",
        body: <p>A visit that ends without a repair carries a $59 diagnostic fee. If we do the repair, the fee is waived.</p>
    },
    {
        id: 'warranties',
        title: "Warranties",
        body: <p>Any spring we install has a lifetime parts warranty for as long as you own the home. Repairs come with a 2-year labor warranty. Damage caused by impact, misuse or third-party work is not covered.</p>
    },
    {
        id: 'cancellations',
        title: "Cancellations",
        body: <p>You can cancel free of charge up to 2 hours before your arrival window.</p>
    },
    {
        id: 'financing',
        title: "Financing",
        body: <p>A third-party lender provides financing, and the lender's own terms apply.</p>
    },
    {
        id: 'contact',
        title: "Contact",
        body: (
            <p>
                {siteConfig.legalName}, {siteConfig.address}.{' '}
                <a href={siteConfig.phoneHref} className='font-medium text-ink underline underline-offset-4 hover:text-ember'>
                    {siteConfig.phone}
                </a>
                .
            </p>
        )
    }
]

const TermsPage: FC = (): ReactNode => {
    return (
        <LegalPage
            title="Terms of service"
            description="How quotes, fees, warranties, cancellations and financing work at Liftline Door Co."
            note="This is template text for Liftline Door Co., written as a starting point and not as legal advice. Replace it with terms reviewed for your state."
            sections={sections}
        />
    )
}

export default TermsPage
